import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import styles from './SbSharedRefineMenuSearchResults.scss';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { slugify } from '../../../utils/slugify';

function SbSharedRefineMenuSearchResultsComponent(props) {
    const { searchString, onResultClick, isLoading, excludedDisplayNames } = props;
    const results = get(props, 'facetSearch.edges');
    const normalizedResults = (results || []).map(edge => edge.node);
    const resultsToShow = normalizedResults
        .slice(0, 5)
        .filter(result => !excludedDisplayNames.includes(result.displayName));

    let markup;

    if (resultsToShow.length) {
        markup = resultsToShow.map(result => {
            return (
                <div
                    key={result.urlLabel}
                    className={styles.result}
                    onClick={() => onResultClick(result)}
                    data-tn={`search-result-${slugify(result.displayName)}`}
                >
                    <span>{result.displayName}</span>
                    <FormattedNumber value={result.count} />
                </div>
            );
        });
        /**
         * If the results is defined, that means we received a response from the server.
         * Is loading determines wheter the request is in flight or not.
         * The normalizedResults check indicates wheter we do not have any results to show because
         * the user has selected all of them.
         *
         */
    } else if (results && !isLoading && normalizedResults.length === 0) {
        markup = (
            <FormattedMessage
                id="sb.SbMobileRefineMenu.facetSearch.noResults"
                defaultMessage="No results for {searchString}"
                values={{ searchString }}
            />
        );
    } else {
        return null;
    }

    return (
        <div className={styles.container} data-tn={`no-results-${slugify(searchString)}`}>
            {markup}
        </div>
    );
}

SbSharedRefineMenuSearchResultsComponent.propTypes = {
    onResultClick: PropTypes.func.isRequired,
    facetSearch: PropTypes.object.isRequired,
    searchString: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    excludedDisplayNames: PropTypes.array.isRequired,
};

function mapStateToProps(state, props) {
    const { appliedFilters } = state.filters;
    const appliedFilter = appliedFilters.find(o => o.name === props.filterName);
    const excludedDisplayNames = get(appliedFilter, 'values', []).map(value => value.displayName);

    return {
        excludedDisplayNames,
    };
}

export const SbSharedRefineMenuSearchResults = createFragmentContainer(
    connect(mapStateToProps)(SbSharedRefineMenuSearchResultsComponent),
    {
        facetSearch: graphql`
            fragment SbSharedRefineMenuSearchResults_facetSearch on FacetsQueryConnection {
                edges {
                    node {
                        urlLabel
                        displayName
                        count
                    }
                }
            }
        `,
    }
);
